module.exports = __webpack_public_path__ + "static/media/Aussie Page - 2.759fc4a1.png";